import { z } from 'zod';

export const databaseHealthSchema = z.object({
  connected: z.boolean(),
  latencyMs: z.number().nullable(),
  error: z.string().nullable(),
});

/** `ok: false` nunca diz qual `BACKEND_*` nem por quê: o detalhe vai só pro `console.error`. */
export const configHealthSchema = z.object({
  ok: z.boolean(),
});

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  runtime: z.literal('cloudflare-workers'),
  environment: z.string(),
  timestamp: z.iso.datetime(),
  database: databaseHealthSchema,
  config: configHealthSchema,
  /** Repassados no deploy (`scripts/deploy.sh`); `null` fora do pipeline da Cloudflare. */
  commit: z.string().nullable(),
  buildId: z.string().nullable(),
});

export type DatabaseHealth = z.infer<typeof databaseHealthSchema>;
export type ConfigHealth = z.infer<typeof configHealthSchema>;
export type HealthResponse = z.infer<typeof healthResponseSchema>;
